import React from 'react'

import { useRouter } from 'next/router'

import * as S from './styles'
import { useHero } from './useHero'
import { NhShape } from '@/assets/imgs'
import { Text, Typewriter } from '@/components'
import { Hero } from '@/service/api/home'

type HeroContainerProps = {
  /**
   * Data of Hero container
   *
   * @example
   * ```tsx
   * const data = {
   * ...
   * }
   *
   * <HeroContainer heroData={data} />
   * ```
   */
  heroData: Hero
}

export const HeroContainer: React.FC<HeroContainerProps> = ({ heroData }) => {
  const { getHeadingSize } = useHero()
  const router = useRouter()

  const { headingWords, typewriterWords } = heroData

  return (
    <S.FlexContainerHero
      direction="column"
      alignItems="flex-start"
      style={{
        height: '100vh',
        padding: 0,
        maxWidth: '1170px',
      }}
    >
      <div className="container-hero">
        <S.TextContainer>
          {headingWords.map((text) => (
            <Text
              key={text + router.locale}
              size={getHeadingSize()}
              color="primary"
              className="heading"
            >
              {text}
            </Text>
          ))}
        </S.TextContainer>

        <S.ImageWrapper>
          <S.NhImage
            src={NhShape}
            alt="Imagem que representa a nata house"
            width={0}
            height={0}
            priority
          />
        </S.ImageWrapper>
      </div>

      <Typewriter texts={typewriterWords} size={getHeadingSize()} />
    </S.FlexContainerHero>
  )
}
